<template>
  <div class="page-container">

    <div class="page-content">
      <div class="class-name">{{state.className}}</div>
      <div class="content-title" style="margin-top: 38px; margin-bottom: 16px">
        授课老师
      </div>
      <div class="teacher-list">
        <div class="teacher" v-for="item in state.teacherList" :key="item.id" @click="handleGoDetail(item)">
          <van-image
            class="teacher-photo"
            mode="widthFix"
            :src="item.teacherInfo.imagePhoto"
          ></van-image>
          <div class="teacher-name">{{ item.teacherInfo.name }}</div>
          <div class="teacher-info">
            {{ item.teacherInfo.title }}
          </div>
        </div>
      </div>

      <div class="content-title" style="margin-top: 38px">教学视频</div>
      <div class="content-video-list">
        <div
          class="content-item-vedio"
          v-for="(item, index) in state.videoList"
          :key="index"
        >
          <video controls class="video-item" :poster="item.videoImg">
            <source :src="item.videoPath" type="video/mp4" />
          </video>
          <div style="display: flex;justify-content: space-between;align-items: center;">
            <div class="user-name">{{item.teacherName}}</div>
            <div class="date-time">{{item.teachDate}}</div>
          </div>
          <div style="margin-left: 12px;margin-top: 4px;margin-bottom: 14px;font-family: PingFang SC;font-weight: 500;font-size: 15px;color: #535353;">{{item.videoDetail}}</div>
          <div class="subject-content">{{item.subjectDesc}}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { defineComponent, onMounted, reactive, ref } from "vue";
import EmptyDataCard from "@/components/EmptyDataCard.vue";
import { queryClassDetail } from "@/api/user";
import { useRoute,useRouter } from "vue-router";
import { showToast } from "vant";
export default defineComponent({
  name: "GaoBuTeacher",

  components: {
    EmptyDataCard,
  },

  setup() {
    const route = useRoute();
    const router = useRouter();

    console.log(route);

    const state = reactive({
      teacherList: [],
      videoList: [],
      className: null
    });
    onMounted(() => {
      if(route?.query?.token) {
        localStorage.setItem('token', route?.query?.token)
      }
      queryClassDetailData();
    });

    const queryClassDetailData = async () => {
      try {
        const result = await queryClassDetail({
          createOrg: route?.query?.creatOrg,
          id: route?.query?.classId,
        });
        console.log('result: ' + result)
        if (result.code === "00") {
          state.videoList = result.data?.videoList ?? []
          state.teacherList = result.data?.teacherList ?? []
          state.className = result.data?.className ?? '--'
        } else {
        }
      } catch (error) {
        console.log("error:>>>", error);
      }
    };

    const getChildren = (row) => {
      if (!row) {
        return [];
      }
      return row.split("\n");
    };

    function handleGoDetail(row) {
        console.log('row>>>>>', row);
        router.push({
            path: '/teacherDetail',
            query: {
                id: row.teacherInfo.id,
                creatOrg: route?.query?.creatOrg
            }
        })
    }

    return {
      state,
      getChildren,
      handleGoDetail
    };
  },
});
</script>

<style lang="scss" scoped>
.page-container {
  background: #e8f5ff;
  height: 100vh;
  width: 100%;
  overflow-y: scroll;
}

.page-header {
  display: flex;
  align-items: flex-start;
}


.teacher-name {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 19px;
  color: #000000;
  margin-top: 60px;
}

.teacher-title {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #626262;
  margin-top: 8px;
}

.teacher-notes {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 13px;
  color: #626262;
  margin-top: 28px;
}

.page-content {
  margin-top: 34px;
  text-align: left;
  margin-left: 16px;
  margin-right: 16px;
}

.content-title {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 19px;
  color: #000000;
}

.content-item {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #313131;
  line-height: 20px;
  margin-top: 20px;
}

.content-item-row {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #313131;
  line-height: 20px;
  margin-top: 4px;
}

.content-video-list {
  display: flex;
  flex-direction: column;
  margin-top: 24px;
  padding-bottom: 24px;
}

.content-item-vedio {
  background-image: url("../../assets/video-item.png");
  background-repeat: no-repeat;
  width: 100%;
  background-size: cover;
  position: relative;
  background-position: center;
  margin-bottom: 9px;
}

.video-item {
  width: calc(100% - 24px);
  padding: 14px 14px 4px;
  height: 161px;
}

.date-time {
  margin-right: 12px;
  font-family: Source Han Sans SC;
  font-weight: 300;
  font-size: 13px;
  color: #545454;
  line-height: 30px;
}

.teacher-list{
  display: flex;
  width: 100%;
  max-height: 100vh;
  flex-wrap: wrap;
  justify-content: flex-start;
  overflow-y: scroll;
  border-radius: 12px;
  background: white;
}

.teacher {
  width: calc(33% - 27px);
  display: flex;
  flex-direction: column;
  align-items: center;
  background: white;
  padding: 14px;
}

.teacher-photo {
  width: 81.66px;
  height: 88.33px;
}

.teacher-name {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 16px;
  color: #000000;
  margin-top: 10px;
}

.teacher-info {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 12px;
  color: #616161;
  margin-top: 8px;
  white-space: nowrap;
  overflow: hidden;
}

.subject-content {
  position: absolute;
  top: 0px;
  right: 0px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 14px;
  color: #FFFFFF;
  padding: 7px 14px;
  background: #0366C2;
  border-radius: 4px;
}

.class-name {
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 22px;
  color: #000000;
  text-align: center;
}

.user-name {
  margin-left: 12px;
  font-family: PingFang SC;
  font-weight: 500;
  font-size: 17px;
  color: #000000;
  }
</style>